// extracted by mini-css-extract-plugin
export default {"container":"APbP7M"};